var _GLOBAL = {
  BreadCrumb: [{
    key: '/role',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/power',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/userManage',
    value: [{
      title: '系统管理',
      path: '/'
    }]
  }, {
    key: '/subSys',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/dataDictionary',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/routesmanage',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/orgManage',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/globalconfig',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/resourcemanage',
    value: [{
      title: '系统管理',
      path: ''
    }]
  }, {
    key: '/resource',
    value: [{
      title: '我的任务',
      path: ''
    }]
  }]
};
export default _GLOBAL;